define('SageDotCom/DataLayer/Events/contactus',["jquery", "SageDotCom/DataLayer/Events/eventBase"], function ($, EventBase) {

    function ContactUsEvent() {
        EventBase.call(this);
        this.name = "contact_us";
    }

    ContactUsEvent.prototype = Object.create(EventBase.prototype);

    ContactUsEvent.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label) {
        var eventData = {
            'event_name': this.getName(),
            'event_non-int': "0",
            'event_category': "contact",
            'event_action': "call"
        };

        if (scope) {
            var location = this.getLocation(scope);
            var lbl = label || $(scope).attr("data-title") || $(scope).text() || $("a:first", scope).text() || "";

            eventData = $.extend(eventData, {
                'event_label': this.stripHtml(lbl.trim()), // strip any html
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': "",
                'event_name_level_3': "",
                'event_name_level_4': location
            });
        }

        return eventData;
    }

    return new ContactUsEvent();
});
